import { render, staticRenderFns } from "./ClaimsReturnsSearchResults.vue?vue&type=template&id=aa3896c8"
import script from "./ClaimsReturnsSearchResults.vue?vue&type=script&lang=js"
export * from "./ClaimsReturnsSearchResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports